import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/auction/done_shadow.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 17;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	padding-top: 315px;
	background-color: rgba(17, 19, 20, 0.99);

	& > img:first-of-type {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	& > ${Text} {
		font-size: 16px;
		color: #ffffff;
		margin-top: 17px;
		text-align: center;
	}
`;

const StyledPrimaryButtonWrap = styled.div`
	margin-top: 36px;
`;

const StyledCrossWrap = styled.div`
	position: absolute;
	bottom: 40px;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 40px;
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -700px;
	left: 50%;
	transform: translateX(-50%);
	width: 1400px;
	height: 1400px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledCrossWrap,
	StyledPrimaryButtonWrap,
	StyledShadow,
};
